import { Reveal } from "../components/Reveal";
import { DropHeading } from "./DropHeading";

const ITEMS = [
  { key: "living", word: "living", text: "Eco-conscious homes designed around light, air and green.", src: "/images/bedroom-morning.webp", alt: "A bedroom opening onto greenery in morning light" },
  { key: "celebrating", word: "celebrating", text: "Spaces made for gatherings that run late into the night.", src: "/images/bonfire-corner.webp", alt: "A bonfire corner set among plants at night" },
  { key: "reconnecting", word: "reconnecting", text: "Long lunches, slow mornings and time with the people around you.", src: "/images/long-lunch.jpg", alt: "A long lunch laid out beside a courtyard pool" },
];

export const ErthExperiences = () => (
  <section id="experiences" data-testid="erth-experiences" className="bg-erth-black py-20 text-erth-white lg:py-36">
    <div className="mx-auto max-w-7xl px-6 sm:px-8">
      <Reveal className="max-w-2xl">
        <p className="mb-6 font-body text-sm tracking-[0.25em] text-erth-white/50">experiences</p>
        <DropHeading
          testId="erth-experiences-heading"
          text="redefining living, celebrating and reconnecting"
          className="text-3xl leading-[1.15] sm:text-4xl lg:text-5xl"
        />
      </Reveal>
      <div className="mt-14 grid gap-8 sm:grid-cols-3 lg:mt-20 lg:gap-10">
        {ITEMS.map((it, i) => (
          <Reveal key={it.key} delay={i * 0.1}>
            <figure data-testid={`erth-experience-${it.key}`} className="group">
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={it.src}
                  alt={it.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                />
              </div>
              <figcaption className="mt-5">
                <p className="font-head text-2xl font-semibold lowercase">{it.word}</p>
                <p className="mt-2 font-body text-base font-light leading-relaxed text-erth-white/70">{it.text}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
